import { render, staticRenderFns } from "./AccountManage.vue?vue&type=template&id=49bc49bb&scoped=true"
import script from "./AccountManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountManage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccountManage.vue?vue&type=style&index=0&id=49bc49bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bc49bb",
  null
  
)

export default component.exports